import { fromJS } from 'immutable';

export const getClickedBoundary = (state) => state.map.get('clickedBoundary');

export const getBatchClickedBoundaries = (state) => state.map.get('batchClickedBoundaries');

export const getViewPort = (state) => state.map.get('viewPort');

export const getDrawingMode = (state) => state.map.get('drawingMode');

export const getVisibleLayers = (state) => state.map.get('visibleLayers');

export const getLeftSplitLayer = (state) => state.map.get('leftSplitLayer');

export const getRightSplitLayer = (state) => state.map.get('rightSplitLayer');

export const getHiddenLayerClasses = (state, layerId) =>
  state.map.getIn(['hiddenLayerClasses', layerId]) || fromJS([]);
